/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/checkbox-button/custom-elements';

import { defineCustomElement as defineOsdsCheckboxButton } from '@ovhcloud/ods-stencil/components/checkbox-button/custom-elements/osds-checkbox-button.js';


export const OsdsCheckboxButton = /*@__PURE__*/ defineContainer<JSX.OsdsCheckboxButton>('osds-checkbox-button', defineOsdsCheckboxButton, [
  'checked',
  'checking',
  'color',
  'disabled',
  'hasFocus',
  'indeterminate',
  'interactive',
  'size'
]);

